import quickenLoans from '@cred/global-assets/images/logos/rocket-mortgage/RocketMortgage-RGB-Horizontal-2048px.png'

import northpointe from 'mortgage-combined/assets/broker-light-lenders/northpointe.png'
import caliberHomeLoans from 'mortgage-combined/assets/lenders/caliber.png'
import loanDepot from 'mortgage-combined/assets/lenders/loandepot.png'
import unitedWholesaleMortgage from 'mortgage-combined/assets/lenders/uwm.png'
import homePoint from 'mortgage-combined/assets/lenders/homepoint.svg'
import allied from 'mortgage-combined/assets/broker-light-lenders/allied.svg'
import nasm from 'mortgage-combined/assets/broker-light-lenders/nasm.svg'
import nations from 'mortgage-combined/assets/broker-light-lenders/nations.svg'
import unionhome from 'mortgage-combined/assets/broker-light-lenders/unionhome.svg'
import naf from 'mortgage-combined/assets/broker-light-lenders/naf.svg'
import rocket from 'mortgage-combined/assets/broker-light-lenders/rocket.svg'
import rocketMobile from 'mortgage-combined/assets/broker-light-lenders/rocket-mobile-logo.svg'
import better from 'mortgage-combined/assets/broker-light-lenders/better.svg'
import nbkc from 'mortgage-combined/assets/broker-light-lenders/NBKC.svg'
import homefinity from 'mortgage-combined/assets/broker-light-lenders/homefinity.png'
import omaha from 'mortgage-combined/assets/broker-light-lenders/omaha.svg'
import filo from 'mortgage-combined/assets/broker-light-lenders/filo.png'
import farmers from 'mortgage-combined/assets/broker-light-lenders/farmers.png'
import veterans from 'mortgage-combined/assets/broker-light-lenders/veterans.svg'
import novus from 'mortgage-combined/assets/broker-light-lenders/novus.svg'

export default (slug, isMobile) => {
  const images = {
    caliber_home_loans: caliberHomeLoans,
    loan_depot: loanDepot,
    quicken_loans: quickenLoans,
    united_wholesale_mortgage: unitedWholesaleMortgage,
    homepoint: homePoint,
    nations,
    nasb: nasm,
    uhm: unionhome,
    allied,
    naf,
    nbkc,
    better_mortgage: better,
    rocket_mortgage: rocket,
    homefinity,
    mutual_of_omaha: omaha,
    northpointe_bank: northpointe,
    filo,
    farmers_bank: farmers,
    veterans_united: veterans,
    novus,
  }

  return slug === 'rocket_mortgage' && isMobile ? rocketMobile : images[slug]
}
